import * as React from 'react'
import * as API from '../lib/api'

interface IProps {
  customer: API.ICustomer
}

export class Customer extends React.Component<IProps, object> {
  public render() {
    const { customer } = this.props
    const {
      first_name: firstName,
      last_name: lastName,
      email,
      company,
    } = customer

    return (
      <>
        {firstName} {lastName} ({email}) <br />
        {this.renderCompany(company)}
      </>
    )
  }

  private renderCompany(company?: string) {
    if (!company) { return null }

    return (
      <>
        {company}
        <br />
      </>
    )
  }
}
